// Libraries
import React from 'react';
import {BrowserRouter} from 'react-router-dom';

// App
import {ClientType} from '@supermove/graphql';

import App from './App';

interface BrowserProps {
  client: ClientType;
  children: React.ReactNode;
}

const Browser = ({client, children}: BrowserProps) => (
  <App client={client}>
    <BrowserRouter>{children}</BrowserRouter>
  </App>
);

export default Browser;
